import Base from '@studiometa/js-toolkit';
import Accordion from '@studiometa/js-toolkit/components/Accordion';
import { isDev } from './config';
import Header from './components/Header';
import Slider from './components/Slider';
import StickyScroll from './components/StickyScroll';
import Share from './components/Share';
import Scroll from './components/Scroll';
import ScrollTop from './components/ScrollTop';
import Overlay from './components/Overlay';
import ImageSwapper from './components/ImageSwapper';

/**
 * Main App class.
 */
class App extends Base {
  /**
   * App config.
   * @return {Object}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      Slider,
      Header,
      StickyScroll,
      Accordion,
      Share,
      Scroll,
      ScrollTop,
      Overlay,
      ImageSwapper,
    },
  };

  /**
   * Loader instance
   */
  get overlayInstance() {
    return this.$children.Overlay[0];
  }

  /**
   * Mount component
   *
   * @return {void}
   */
  mounted() {
    const allLinks = document.querySelectorAll('a[href]');

    window.addEventListener('unload', () => {
      this.overlayInstance.$el.classList.add('overlay--hide');
    });

    allLinks.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const link = e.currentTarget;

        if (link.href) {
          this.overlayInstance.$el.classList.remove('overlay--hide');
        }

        setTimeout(() => {
          window.location.href = link.href;
        }, 400);
      });
    });
  }
}

const app = new App(document.body);
window.app = app;
app.$mount();

export default app;
